import { useCallback, useRef } from "react";

export function useTripleClick({
  delay = 500,
  onTripleClick,
}: {
  delay?: number;
  onTripleClick?: (event: MouseEvent) => void;
}) {
  const clickCount = useRef(0);
  const clickTimer = useRef<ReturnType<typeof setTimeout> | null>(null);
  const lastClickTime = useRef(0);

  const handleClick = useCallback(
    (event: MouseEvent) => {
      const now = Date.now();
      if (now - lastClickTime.current > delay) {
        clickCount.current = 0;
      }

      clickCount.current += 1;
      lastClickTime.current = now;

      if (clickTimer.current) clearTimeout(clickTimer.current);

      clickTimer.current = setTimeout(() => {
        if (clickCount.current === 3) onTripleClick?.(event);
        clickCount.current = 0;
      }, delay);
    },
    [delay, onTripleClick]
  );

  const reset = useCallback(() => {
    clickCount.current = 0;
    if (clickTimer.current) {
      clearTimeout(clickTimer.current);
      clickTimer.current = null;
    }
    lastClickTime.current = 0;
  }, []);

  return { handleClick, reset };
}
